/* src/app/warehousing/pages/locations-edit/locations-edit.component.scss */
/*# sourceMappingURL=locations-edit.component.css.map */
